import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_MOCKUP_URL } from './constants';
export function Hero({
  ctaEndRef
}: {
  ctaEndRef?: React.RefObject<HTMLDivElement>;
}) {
  return <section className="relative overflow-hidden bg-cream px-4 pb-10 pt-8 sm:pt-12" data-id="element-120">
      <div className="mx-auto max-w-3xl text-center" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mx-auto mb-5 inline-flex items-center gap-2 rounded-full border border-brandpurple/30 bg-brandpurple/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-brandpurple" data-id="element-122">
          <span className="h-1.5 w-1.5 rounded-full bg-magenta" data-id="element-123" />
          Método Domingo Libre™ · Por Karito Educa
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="font-display text-4xl font-black leading-[1.05] text-navy sm:text-5xl md:text-6xl" data-id="element-124">
          ¿Hasta cuándo vas a seguir cambiando tus domingos por planeaciones
          interminables?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.12
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-navy/70 sm:text-lg" data-id="element-125">
          Recupera el control de tu semana, deja de improvisar tus clases y
          vuelve a tener tiempo para ti y tu familia con el{' '}
          <span className="mt-1 inline-block font-display text-xl font-black italic text-magenta sm:text-2xl" data-id="element-126">
            Método Domingo Libre™
          </span>
        </motion.p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.18
    }} className="mx-auto mt-8 max-w-2xl" data-id="element-127">
        <div className="animate-float-slow" data-id="element-128">
          <img src={HERO_MOCKUP_URL} alt="Método Domingo Libre — 6 tomos, plan docente y video taller" className="mx-auto w-full max-w-xl drop-shadow-[0_25px_35px_rgba(30,42,110,0.25)]" data-id="element-129" />
        </div>
      </motion.div>

      <div className="mx-auto mt-6 max-w-md" data-id="element-130">
        <CtaButton data-id="element-131" />
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-navy/70 sm:text-sm" data-id="element-132">
          <span className="inline-flex items-center gap-1.5" data-id="element-133">
            <FileTextIcon className="h-4 w-4 text-brandpurple" data-id="element-134" /> 100% PDF
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-135">
            <ZapIcon className="h-4 w-4 text-magenta" data-id="element-136" /> Acceso en 5 min
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-137">
            <GlobeIcon className="h-4 w-4 text-teal" data-id="element-138" /> Todo Latinoamérica
          </span>
        </div>
      </div>

      <div ref={ctaEndRef} aria-hidden="true" className="h-px w-full" data-id="element-139" />
    </section>;
}